import PropTypes from 'prop-types';

import RuleSummary from './RuleSummary';

/**
 * Read-only sibling of XAllOfBuilder used in view mode. Skips edit affordances
 * (Add Rule, Delete, Duplicate, validation badges) entirely and renders each
 * rule as a narrative summary with optional expand-to-detail.
 */
export default function XAllOfRulesView({ rules }) {
	if (!Array.isArray(rules) || rules.length === 0) return null;

	return (
		<section
			className="dsv-view__xallof"
			data-testid="dsv-view-xallof-section"
			style={sectionStyle}
		>
			<header style={headerStyle}>
				<h4 style={titleStyle}>Conditional Validation Rules ({rules.length})</h4>
				<p style={subtitleStyle}>
					These if/then/else rules apply field constraints only when specific
					conditions are met. Click a rule to see the fields it affects.
				</p>
			</header>

			{rules.map((rule, index) => (
				<RuleSummary key={rule.id || index} rule={rule} ruleIndex={index} />
			))}
		</section>
	);
}

XAllOfRulesView.propTypes = {
	rules: PropTypes.array.isRequired,
};

const sectionStyle = {
	marginTop: '24px',
	padding: '16px',
	background: '#fff',
	border: '1px solid #e5e7eb',
	borderRadius: '8px',
};
const headerStyle = { marginBottom: '8px' };
const titleStyle = { margin: '0 0 4px 0', fontSize: '15px', fontWeight: 600, color: '#111827' };
const subtitleStyle = { margin: 0, fontSize: '12px', color: '#6b7280' };
